module.exports = __webpack_public_path__ + "media/images/telegram-a228b381dd0b1d770ad35e5f36aa8544.svg";